import PropTypes from 'prop-types';
import React from 'react';
/* eslint-disable-next-line no-restricted-imports */

import { Router } from 'react-router-dom';
import RouterContext from "./RouterContext";
/* eslint-disable-next-line no-restricted-imports */

const ContextWrapper = (props, context) => {
  const {
    history,
    route: {
      location,
      match
    } = {}
  } = context.router;
  return /*#__PURE__*/React.createElement(RouterContext.Provider, {
    value: {
      location,
      history,
      match
    }
  }, props.children);
};

ContextWrapper.contextTypes = {
  router: PropTypes.shape({
    history: PropTypes.object.isRequired,
    route: PropTypes.object.isRequired,
    staticContext: PropTypes.object
  })
};
/**
 * Wraps react-router's Router children with context to support hooks (useLocation, useParams etc).
 * Check ./hooks/index.js for hooks implemetation.
 */

export const RouterWithContext = props => {
  const {
    children,
    history
  } = props;
  return /*#__PURE__*/React.createElement(Router, {
    history: history
  }, /*#__PURE__*/React.createElement(ContextWrapper, null, children));
};